import { memo } from 'react'
import styled from 'styled-components'
import { Text } from '@pancakeswap/uikit'
import { useLocation, useNavigate } from 'react-router-dom'

const THEME = {
  primary: '#1fc7d4',
  primaryDark: '#12a5b1',
  primarySoft: 'rgba(31, 199, 212, 0.1)',
  ink: '#0b1a1d',
  line: 'rgba(11, 26, 29, 0.07)',
}

const PageSwapper = styled.div.attrs({ 'data-dropdown': true })<{ $height: number }>`
  width: 280px;
  height: ${({ $height }) => $height * 52 + 20}px;
  position: absolute;
  top: 100%;
  left: 50%;
  z-index:999;
  transform: translate(-50%, -6px);
  padding: 10px;
  border-radius: 18px;
  text-align: start;

  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: saturate(180%) blur(24px);
  -webkit-backdrop-filter: saturate(180%) blur(24px);

  border: 1px solid ${THEME.line};
  box-shadow:
    0 2px 6px rgba(11, 26, 29, 0.04),
    0 24px 48px -18px rgba(11, 26, 29, 0.22),
    0 0 0 4px rgba(31, 199, 212, 0.06);

  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    opacity 0.22s ease,
    transform 0.26s cubic-bezier(0.4, 0, 0.2, 1),
    visibility 0.26s ease;

  /* 箭头：定位到面板顶部正中 */
  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 50%;
    margin-left: -10px;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-bottom-color: ${THEME.primary};
    top: -20px;
  }

  &::after {
    border-bottom-color: #fff;
    top: -19px;
  }
`

const PageItem = styled.div`
  position: relative;
  height: 52px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.22s ease, transform 0.22s ease;

  /* 左侧主题色指示条，hover 时淡入 */
  &::before {
    content: '';
    position: absolute;
    left: 6px;
    top: 50%;
    width: 3px;
    height: 0;
    border-radius: 3px;
    background: linear-gradient(180deg, ${THEME.primary}, ${THEME.primaryDark});
    transform: translateY(-50%);
    transition: height 0.24s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &:hover {
    background: ${THEME.primarySoft};
    transform: translateX(2px);

    &::before {
      height: 18px;
    }

    span {
      color: ${THEME.primaryDark} !important;
    }
  }
`

interface ItemType {
  label: string
  path: string
}

interface PropsType {
  items: ItemType[]
}

function App(props: PropsType) {
  const { items } = props
  const navigate = useNavigate()
  const location = useLocation()

  const pageItemClick = (item: ItemType) => {
    navigate({
      pathname: item.path,
      search: location.search,
    })
  }

  return (
    <PageSwapper $height={items.length}>
      {items.map((item) => (
        <PageItem key={item.label} onClick={() => pageItemClick(item)}>
          <Text color={THEME.ink}>{item.label}</Text>
        </PageItem>
      ))}
    </PageSwapper>
  )
}

export default memo(App)
